import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    IconButton,
    Menu,
    MenuItem,
    Checkbox,
    Typography,
    Button,
    TextField,
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

import SideNav from '../../common/SideNav';
import RuleEditor from '../../common/RuleEditor';
import {
    hasSideBar,
    toggleSideBar,
    updateCurrentComponent,
} from '../../../store/actions/navActions';
import {
    hideLoading,
    showLoading,
} from '../../../store/actions/loadingActions';
import { notifyError } from '../../../store/actions/notificationActions';
// import { getRuleList } from '../../../services/api/ruleApi';
import {
    extractEvent,
    extractEventAttribute,
} from '../../../services/ruleUtils';
import {
    asString,
    capitalizeFirstLetter,
    nonEmptyString,
    toUpperCase,
} from '../../../services/typeUtils';
import { formatDate } from '../../../services/formatUtils';
import { Email } from '../../../services/Email';
import * as C from '../../../services/constants';
import { getRuleList } from '../../../services/api/nbaApi';

const manageRulesTableHeader = {
    status: 'Status',
    ruleAppliesTo: 'Rule Id',
    // eventAttribute: 'Event Attribute',
    description: 'Rule Name',
    // createDate: 'Created Date',
    // publishedDate: 'Published Date',
    frequency: 'Frequency',
    loadType: 'Load Type',
    nextRun: 'Next Run',
    mvelExpression: 'MVEL Expression',
    actions: 'Actions',
    // publisherEID: 'Publisher EID',
};

const statusOptions = ['active', 'inactive'];
const ruleAppliesToOptions = [
    'consumer',
    'article',
    'game',
    'video',
    'quiz',
    'raffle',
    'user tier',
];

const CollapsibleMVELExpression = ({ expression }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded((prev) => !prev);

    return (
        <Box
            sx={{
                wordWrap: 'break-word',
                border: '1px solid #ccc',
                borderRadius: 4,
                padding: 1,
                display: 'flex',
                justifyContent: 'space-between',
                // alignItems: 'end'
            }}
        >
            <Typography
                variant="body2"
                component="div"
                sx={{
                    maxWidth: 300,
                    maxHeight: expanded ? 'none' : '1.5em',
                    overflow: expanded ? 'visible' : 'hidden',
                    textOverflow: expanded ? 'clip' : 'ellipsis',
                    whiteSpace: expanded ? 'normal' : 'nowrap',
                }}
            >
                {expression}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'end',
                }}
            >
                <Button
                    size="small"
                    variant="text"
                    onClick={toggleExpanded}
                    sx={{ textTransform: 'none', width: '80px' }}
                >
                    {expanded ? 'Show Less' : 'Show More'}
                </Button>
            </Box>
        </Box>
    );
};

const ManageRulesNew = () => {
    const dispatch = useDispatch();
    const fields = Object.keys(manageRulesTableHeader);
    const { market, category, brand } = useSelector((state) => state.auth.user);

    const [holdDataForSearch, setHoldDataForSearch] = useState([]);
    const [rules, setRules] = useState([]);
    const [ruleId, setRuleId] = useState(null);
    const [showRuleEditor, setShowRuleEditor] = useState(false);
    const [type, setType] = useState(C.RULE_TYPE_NEW);
    const [page, setPage] = useState(0);
    const [sortBy, setSortBy] = useState('status');
    const [sortOrder, setSortOrder] = useState('asc');
    const [filterStatus, setFilterStatus] = useState([]);
    const [filterRuleAppliesTo, setFilterRuleAppliesTo] = useState([]);
    const [anchorElStatus, setAnchorElStatus] = useState(null);
    const [anchorElRuleAppliesTo, setAnchorElRuleAppliesTo] = useState(null);
    const [mvelExpressionSearch, setMVELExpressionSearch] = useState('');

    const handlePageChange = (event, page) => {
        setPage(page);
    };

    const openRuleEditor = (status, ruleId = null) => {
        setRuleId(ruleId);
        setType(status);
        setShowRuleEditor(true);
    };

    const closeRuleEditor = () => {
        setRuleId(null);
        setShowRuleEditor(false);
    };

    useEffect(() => {
        dispatch(updateCurrentComponent(C.APP_MANAGE_RULES_PAGE_TITLE));
        dispatch(hasSideBar(true));
        dispatch(toggleSideBar(false));

        dispatch(showLoading());
        // getRuleList(market, category, brand)
        //     .then((response) => {
        //         const existingRules = response.data.map((rule) => ({
        //             nbaRuleId: rule.nbaRuleId,
        //             status: rule.status,
        //             ruleAppliesTo:
        //                 rule.ruleType === C.RULE_FOR_POINT
        //                     ? extractEvent(rule.condition)
        //                     : C.RULE_PROPERTY_USER_TIER,
        //             ruleType: rule.ruleType,
        //             eventAttribute:
        //                 rule.ruleType === C.RULE_FOR_POINT
        //                     ? extractEventAttribute(rule.condition)
        //                     : '-',
        //             description: rule.description,
        //             publishedDate: formatDate(rule.updatedTs),
        //             publisherEID: new Email(rule.updatedBy).user,
        //         }));
        //         setRules(existingRules);
        //     })
        //     .catch((error) => {
        //         dispatch(notifyError('Error!', 'Unable to fetch rules.'));
        //     })
        //     .finally(() => dispatch(hideLoading()));
        getRuleList(market)
            .then((response) => {
                const existingRules = response.data.map((rule) => ({
                    nbaRuleId: rule.nbaRuleId,
                    status: rule.status,
                    ruleAppliesTo: asString(rule.nbaRuleId),
                    ruleType: rule.namespace,
                    // eventAttribute: rule.action,
                    description: rule.description,
                    // publishedDate: formatDate(rule.createdAt),
                    // createDate: formatDate(rule.updatedAt),
                    // publisherEID: asString(rule.nbaRuleId),
                    mvelExpression: rule.condition,
                }));
                setHoldDataForSearch(existingRules);
                setRules(existingRules);
            })
            .catch((err) => console.log(err))
            .finally(() => dispatch(hideLoading()));
    }, [showRuleEditor]);

    const handleSort = (field) => {
        if (sortBy === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortBy(field);
            setSortOrder('asc');
        }
    };

    const handleFilterStatus = (event) => {
        const { checked, value } = event.target;
        setFilterStatus((prevState) => {
            if (checked && !prevState.includes(value)) {
                return [...prevState, value];
            }
            return prevState.filter((item) => item !== value);
        });
    };

    const handleFilterRuleAppliesTo = (event) => {
        const { checked, value } = event.target;
        setFilterRuleAppliesTo((prevState) => {
            if (checked && !prevState.includes(value)) {
                return [...prevState, value];
            }
            return prevState.filter((item) => item !== value);
        });
    };

    const filteredAndSortedRules = rules
        .filter((rule) => {
            return (
                filterStatus.length === 0 ||
                filterStatus.includes(rule.status.toLowerCase())
            );
        })
        .filter((rule) => {
            return (
                filterRuleAppliesTo.length === 0 ||
                filterRuleAppliesTo.includes(rule.ruleAppliesTo.toLowerCase())
            );
        })
        .sort((a, b) => {
            if (sortOrder === 'asc') {
                return a[sortBy].toLowerCase() > b[sortBy].toLowerCase()
                    ? 1
                    : -1;
            }
            return a[sortBy].toLowerCase() < b[sortBy].toLowerCase() ? 1 : -1;
        });

    const renderFieldContent = (field, rule) => {
        if (field === C.RULE_PROPERTY_STATUS) {
            switch (rule[field]) {
                case C.RULE_TYPE_PUBLISHED:
                    return (
                        <span
                            className="view-rule published"
                            onClick={() =>
                                rule.ruleType !== C.RULE_FOR_TIER &&
                                openRuleEditor(
                                    C.RULE_TYPE_PUBLISHED,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            {/* Published */}
                            Active
                        </span>
                    );
                case C.RULE_TYPE_DRAFT:
                    return (
                        <span
                            className="view-rule draft"
                            onClick={() =>
                                openRuleEditor(
                                    C.RULE_TYPE_DRAFT,
                                    rule.nbaRuleId
                                )
                            }
                        >
                            {/* Draft */}
                            Inactive
                        </span>
                    );
                // case C.RULE_TYPE_EXPIRED:
                //     return (
                //         <span
                //             className="view-rule expired"
                //             onClick={() =>
                //                 openRuleEditor(C.RULE_TYPE_EXPIRED, rule.nbaRuleId)
                //             }
                //         >
                //             Expired
                //         </span>
                //     );
                default:
                    return '-';
            }
        } else if (field === C.RULE_PROPERTY_PUBLISHED_DATE) {
            if (rule[C.RULE_PROPERTY_STATUS] === C.RULE_TYPE_PUBLISHED) {
                return nonEmptyString(rule[field]) && rule[field];
            } else {
                return '-';
            }
        } else if (field === C.RULE_PROPERTY_MVEL_EXPRESSION) {
            return (
                <CollapsibleMVELExpression
                    key={rule.nbaRuleId}
                    expression={rule[field]}
                />
            );
        } else if (nonEmptyString(rule[field])) {
            return rule[field];
        } else if (field === C.RULE_PROPERTY_ACTIONS) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        gap: '8px',
                    }}
                >
                    <Button
                        style={{
                            alignSelf: 'flex-start',
                            background: '#1976d2',
                            color: '#fff',
                            borderRadius: 4,
                            padding: '4px 12px',
                            fontSize: '0.95rem',
                            textTransform: 'none',
                        }}
                        onMouseOver={e => e.currentTarget.style.background = '#115293'}
                        onMouseOut={e => e.currentTarget.style.background = '#1976d2'}
                    >
                        Edit
                    </Button>
                    <Button
                        style={{
                            alignSelf: 'flex-start',
                            background: '#ffb300',
                            color: '#fff',
                            borderRadius: 4,
                            padding: '4px 12px',
                            fontSize: '0.95rem',
                            textTransform: 'none',
                        }}
                        onMouseOver={e => e.currentTarget.style.background = '#b28704'}
                        onMouseOut={e => e.currentTarget.style.background = '#ffb300'}
                    >
                        Deactivate
                    </Button>
                    <Button
                        style={{
                            alignSelf: 'flex-start',
                            background: '#d32f2f',
                            color: '#fff',
                            borderRadius: 4,
                            padding: '4px 12px',
                            fontSize: '0.95rem',
                            textTransform: 'none',
                        }}
                        onMouseOver={e => e.currentTarget.style.background = '#9a0007'}
                        onMouseOut={e => e.currentTarget.style.background = '#d32f2f'}
                    >
                        Delete
                    </Button>
                </div>
            );
        } else {
            return '-';
        }
    };

    const handleSearch = () => {
        if (!mvelExpressionSearch.trim()) {
            setRules(holdDataForSearch);
        } else {
            const filteredData = rules.filter((row) =>
                row[C.RULE_PROPERTY_MVEL_EXPRESSION]
                    ?.toLowerCase()
                    .includes(mvelExpressionSearch.toLowerCase())
            );
            setRules(filteredData); // `filteredData` is the state to store the filtered table data
        }
    };

    const renderField = (field) => {
        const commonHeader = <>{manageRulesTableHeader[field]}</>;

        if (field === 'status') {
            return (
                <>
                    {commonHeader}
                    <IconButton onClick={() => handleSort(field)}>
                        {sortBy === field &&
                            (sortOrder === 'asc' ? (
                                <ArrowUpwardIcon />
                            ) : (
                                <ArrowDownwardIcon />
                            ))}
                    </IconButton>
                    <IconButton
                        onClick={(event) =>
                            setAnchorElStatus(event.currentTarget)
                        }
                    >
                        <FilterListIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorElStatus}
                        open={Boolean(anchorElStatus)}
                        onClose={() => setAnchorElStatus(null)}
                    >
                        {statusOptions.map((option) => (
                            <MenuItem key={option}>
                                <Checkbox
                                    checked={filterStatus.includes(option)}
                                    onChange={handleFilterStatus}
                                    value={option}
                                />
                                {capitalizeFirstLetter(option)}
                            </MenuItem>
                        ))}
                    </Menu>
                </>
            );
        }

        if (field === 'ruleAppliesTo') {
            return (
                <>
                    {commonHeader}
                    {/* <IconButton onClick={(event) => setAnchorElRuleAppliesTo(event.currentTarget)}>
                        <FilterListIcon />
                    </IconButton>
                    <Menu
                        anchorEl={anchorElRuleAppliesTo}
                        open={Boolean(anchorElRuleAppliesTo)}
                        onClose={() => setAnchorElRuleAppliesTo(null)}
                    >
                        {ruleAppliesToOptions.map((option) => (
                            <MenuItem key={option}>
                                <Checkbox
                                    checked={filterRuleAppliesTo.includes(option)}
                                    onChange={handleFilterRuleAppliesTo}
                                    value={option}
                                />
                                {toUpperCase(option)}
                            </MenuItem>
                        ))}
                    </Menu> */}
                </>
            );
        }

        if (field === 'mvelExpression') {
            return (
                <>
                    <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                    >
                        {commonHeader}
                        {/* <div style={{ display: 'flex', alignItems: 'center', maxWidth: '300px' }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                style={{ flex: 1 }}
                                onChange={(e) => setMVELExpressionSearch(e.target.value)}
                                value={mvelExpressionSearch}
                            />
                            <IconButton onClick={handleSearch}>
                                <SearchIcon />
                            </IconButton>

                        </div> */}
                        <div
                            className="search-container"
                            style={{ margin: '10px' }}
                        >
                            <input
                                type="text"
                                placeholder="Search"
                                className="search-box"
                                onChange={(e) =>
                                    setMVELExpressionSearch(e.target.value)
                                }
                            />
                            <SearchIcon
                                className="search-icon"
                                onClick={handleSearch}
                            />
                        </div>
                    </Box>
                </>
            );
        }

        if (field === 'Actions') {
            return (
                <>
                    <Box
                        display={'flex'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                    >
                        {commonHeader}
                        {/* <div style={{ display: 'flex', alignItems: 'center', maxWidth: '300px' }}>
                            <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                style={{ flex: 1 }}
                                onChange={(e) => setMVELExpressionSearch(e.target.value)}
                                value={mvelExpressionSearch}
                            />
                            <IconButton onClick={handleSearch}>
                                <SearchIcon />
                            </IconButton>

                        </div> */}
                        <div style={{ margin: '10px' }}>
                            <Button></Button>
                        </div>
                    </Box>
                </>
            );
        }

        return commonHeader; // Default for other fields
    };

    return (
        <div className="component-container-root">
            <SideNav />
            {showRuleEditor ? (
                <RuleEditor
                    status={showRuleEditor}
                    type={type}
                    ruleId={ruleId}
                    onClose={closeRuleEditor}
                    origin={C.RULE_EDITOR_MANAGE_PROGRAM}
                />
            ) : (
                <Box className="manage-rules-container component-container">
                    <p className="instruction">
                        View and manage the rules of the nba program. Go to '
                        <Link to="/help">Help page</Link>' for information on
                        how to manage.
                    </p>
                    <div
                        className="manage-rules"
                        style={{ textWrap: 'nowrap' }}
                    >
                        <TableContainer className="table-container">
                            <Table className="table">
                                <TableHead className="table-head">
                                    <TableRow className="table-row">
                                        {fields.map((field, idx) => (
                                            // <TableCell
                                            //     key={idx}
                                            //     className="table-cell"
                                            // >
                                            //     {field === 'status' ? (
                                            //         <>
                                            //             {
                                            //                 manageRulesTableHeader[
                                            //                     field
                                            //                 ]
                                            //             }
                                            //             <IconButton
                                            //                 onClick={() =>
                                            //                     handleSort(
                                            //                         field
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 {sortBy === field &&
                                            //                     (sortOrder ===
                                            //                     'asc' ? (
                                            //                         <ArrowUpwardIcon />
                                            //                     ) : (
                                            //                         <ArrowDownwardIcon />
                                            //                     ))}
                                            //             </IconButton>
                                            //             <IconButton
                                            //                 onClick={(event) =>
                                            //                     setAnchorElStatus(
                                            //                         event.currentTarget
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 <FilterListIcon />
                                            //             </IconButton>
                                            //             <Menu
                                            //                 anchorEl={
                                            //                     anchorElStatus
                                            //                 }
                                            //                 open={Boolean(
                                            //                     anchorElStatus
                                            //                 )}
                                            //                 onClose={() =>
                                            //                     setAnchorElStatus(
                                            //                         null
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 {statusOptions.map(
                                            //                     (option) => (
                                            //                         <MenuItem
                                            //                             key={
                                            //                                 option
                                            //                             }
                                            //                         >
                                            //                             <Checkbox
                                            //                                 checked={filterStatus.includes(
                                            //                                     option
                                            //                                 )}
                                            //                                 onChange={
                                            //                                     handleFilterStatus
                                            //                                 }
                                            //                                 value={
                                            //                                     option
                                            //                                 }
                                            //                             />
                                            //                             {capitalizeFirstLetter(
                                            //                                 option
                                            //                             )}
                                            //                         </MenuItem>
                                            //                     )
                                            //                 )}
                                            //             </Menu>
                                            //         </>
                                            //     ) : field ===
                                            //       'ruleAppliesTo' ? (
                                            //         <>
                                            //             {
                                            //                 manageRulesTableHeader[
                                            //                     field
                                            //                 ]
                                            //             }
                                            //             <IconButton
                                            //                 onClick={() =>
                                            //                     handleSort(
                                            //                         field
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 {sortBy === field &&
                                            //                     (sortOrder ===
                                            //                     'asc' ? (
                                            //                         <ArrowUpwardIcon />
                                            //                     ) : (
                                            //                         <ArrowDownwardIcon />
                                            //                     ))}
                                            //             </IconButton>
                                            //             <IconButton
                                            //                 onClick={(event) =>
                                            //                     setAnchorElRuleAppliesTo(
                                            //                         event.currentTarget
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 <FilterListIcon />
                                            //             </IconButton>
                                            //             <Menu
                                            //                 anchorEl={
                                            //                     anchorElRuleAppliesTo
                                            //                 }
                                            //                 open={Boolean(
                                            //                     anchorElRuleAppliesTo
                                            //                 )}
                                            //                 onClose={() =>
                                            //                     setAnchorElRuleAppliesTo(
                                            //                         null
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 {ruleAppliesToOptions.map(
                                            //                     (option) => (
                                            //                         <MenuItem
                                            //                             key={
                                            //                                 option
                                            //                             }
                                            //                         >
                                            //                             <Checkbox
                                            //                                 checked={filterRuleAppliesTo.includes(
                                            //                                     option
                                            //                                 )}
                                            //                                 onChange={
                                            //                                     handleFilterRuleAppliesTo
                                            //                                 }
                                            //                                 value={
                                            //                                     option
                                            //                                 }
                                            //                             />
                                            //                             {toUpperCase(
                                            //                                 option
                                            //                             )}
                                            //                         </MenuItem>
                                            //                     )
                                            //                 )}
                                            //             </Menu>
                                            //         </>
                                            //     ) : (
                                            //         <>
                                            //             {
                                            //                 manageRulesTableHeader[
                                            //                     field
                                            //                 ]
                                            //             }
                                            //             <IconButton
                                            //                 onClick={() =>
                                            //                     handleSort(
                                            //                         field
                                            //                     )
                                            //                 }
                                            //             >
                                            //                 {sortBy === field &&
                                            //                     (sortOrder ===
                                            //                     'asc' ? (
                                            //                         <ArrowUpwardIcon />
                                            //                     ) : (
                                            //                         <ArrowDownwardIcon />
                                            //                     ))}
                                            //             </IconButton>
                                            //         </>
                                            //     )}
                                            // </TableCell>
                                            <TableCell
                                                key={idx}
                                                className={`table-cell ${
                                                    field ===
                                                    C.RULE_PROPERTY_MVEL_EXPRESSION
                                                        ? 'mvelExpressionCell'
                                                        : ''
                                                }`}
                                            >
                                                {renderField(field)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody className="table-body">
                                    {filteredAndSortedRules
                                        .slice(page * 10, page * 10 + 10)
                                        .map((rule, rowIndex) => (
                                            <TableRow
                                                key={rowIndex}
                                                className={`table-row ${
                                                    rule.ruleType ===
                                                    C.RULE_FOR_TIER
                                                        ? 'tier-rule'
                                                        : 'point-rule'
                                                }`}
                                            >
                                                {fields.map((field, idx) =>
                                                    /* Previous (no wrap) version:
    <TableCell key={idx} className="table-cell" >
        {renderFieldContent(field, rule)}
    </TableCell>
    */
                                                    field === 'description' ? (
                                                        <TableCell
                                                            key={idx}
                                                            className="table-cell"
                                                            style={{
                                                                whiteSpace:
                                                                    'normal',
                                                                wordBreak:
                                                                    'break-word',
                                                                maxWidth: 250,
                                                            }}
                                                        >
                                                            {renderFieldContent(
                                                                field,
                                                                rule
                                                            )}
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell
                                                            key={idx}
                                                            className="table-cell"
                                                        >
                                                            {renderFieldContent(
                                                                field,
                                                                rule
                                                            )}
                                                        </TableCell>
                                                    )
                                                )}
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                            <div className="table-footer">
                                <button
                                    className="add-rule"
                                    onClick={() =>
                                        openRuleEditor(C.RULE_TYPE_NEW)
                                    }
                                >
                                    + Add Rule
                                </button>
                                <TablePagination
                                    component="div"
                                    count={filteredAndSortedRules.length}
                                    rowsPerPage={10}
                                    rowsPerPageOptions={[]}
                                    page={page}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        </TableContainer>
                    </div>
                </Box>
            )}
        </div>
    );
};

export default ManageRulesNew;
